import React, { useEffect, lazy } from 'react';
import {Route, Routes} from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import '../../styles/index.scss';

// import Home from '../../pages/Home/Home'
// import Services from '../../pages/Services/Services'
// import Portfolio from '../../pages/Portfolio/Portfolio'
// import AboutUs from '../../pages/AboutUs/AboutUs'
// import Contact from '../../pages/Contact/Contact'

const Home = lazy(() => import('../Home/Home.jsx'));
// const Home = lazy(() => {
//   return new Promise(resolve => setTimeout(resolve, 3000)).then(
//     () => import('../Home/Home.jsx')
//   );
// });

const Services = lazy(() => import('../Services/Services.jsx'));
const Portfolio = lazy(() => import('../Portfolio/Portfolio.jsx'));
const AboutUs = lazy(() => import('../AboutUs/AboutUs.jsx'));
const Contact = lazy(() => import('../Contact/Contact.jsx'));


const App = () => {
  useEffect(() => {
    // const script1 = document.createElement('script');
    const script2 = document.createElement('script');
    const script3 = document.createElement('script');
    const script4 = document.createElement('script');
    // script1.src = "https://cdn.jsdelivr.net/npm/emailjs-com@3/dist/email.min.js";
    // script1.async = true;
    script2.src = "https://www.googletagmanager.com/gtag/js?id=G-Z47QFN7XWM";
    script2.async = true;
    script3.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());

      gtag('config', 'G-Z47QFN7XWM');
    `;
    script3.async = true;
    script4.src = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '868013279519784');
      fbq('track', 'PageView');
    `;
    script4.async = true;
    // document.head.appendChild(script1);
    document.head.appendChild(script2);
    document.head.appendChild(script3);
    document.head.appendChild(script4);
    return () => {
      // document.head.removeChild(script1);
      document.head.removeChild(script2);
      document.head.removeChild(script3);
      document.head.removeChild(script4);
    }
  }, []);

  return (
    <div>
      <Routes>
        <Route
          path="/"
          element={(
            <React.Suspense fallback={<Loader/>}>
              <Home/>
            </React.Suspense>
          )}
        />
        <Route
          path="/services"
          element={(
            <React.Suspense fallback={<Loader/>}>
              <Services/>
            </React.Suspense>
          )}
        />
        <Route
          path="/portfolio"
          element={(
            <React.Suspense fallback={<Loader/>}>
              <Portfolio/>
            </React.Suspense>
          )}
        />
        <Route
          path="/about"
          element={(
            <React.Suspense fallback={<Loader/>}>
              <AboutUs/>
            </React.Suspense>
          )}
        />
        <Route
          path="/contact"
          element={(
            <React.Suspense fallback={<Loader/>}>
              <Contact/>
            </React.Suspense>
          )}
        />
      </Routes>
    </div>
  )
}
export default App



